import { getMonoDashboardUrl } from './mono-dashboard';
import { getMonoWeatherwidgetUrl } from './mono-weatherwidget';
export { getMonoDashboardUrl, getMonoWeatherwidgetUrl };
